import NotFound404View from '@legacy/components/Auth/NotFound404View'
import SiteNavigation from '@legacy/components/Website/SiteNavigation'
import { useWebsite } from '@legacy/contexts/websiteContext'

export const NotFound = () => {
  const { productSiteConfig } = useWebsite()

  return (
    <>
      <SiteNavigation navigation={productSiteConfig.navigation} />
      <NotFound404View />
    </>
  )
}
